<template>
    <div class="blog-grid-item mb-30px position-relative">
        <img v-if="item.img" :src="item.img" alt="Blog">

        <div class="blog-grid-item-content">
            <div class="blog-grid-user-meta d-flex position-relative align-center">
                <img v-if="item.authorImage" :src="item.authorImage" alt="">
                <div class="blog-grid-user-content">
                    <h4 v-if="item.author">by <a :href="item.authorUrl">{{item.author}}</a></h4>
                    <span v-if="item.date" class="date">{{item.date}}</span>
                </div>
            </div>

            <ul class="blog-tags d-flex align-center" v-if="item.tags.length">
                <li v-for="tag in item.tags" :key="tag"><a :href="tag.url">{{tag.title}}</a></li>
            </ul>
            <h1 v-if="item.title"><router-link :to="item.url">{{item.title}}</router-link></h1>
        </div>
    </div>

</template>

<script>
export default {
    name: 'BlogItem', 
    props: ['item'],
    data() {
        return {

        }
    }
}
</script>